module.exports = __webpack_public_path__ + "static/media/about-icon-consult.3920d141.svg";